import React from 'react'
import styles from './styles.css'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import Page from './Page'
import autobind from 'autobind-decorator'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import keys from 'lodash/keys'
import Button from 'orionsoft-parts/lib/components/Button'
import FixedHeader from 'App/components/FixedHeader'
import TwoFactor from 'App/components/TwoFactor'
import {withRouter} from 'react-router'
import each from 'lodash/each'
import VerifyAlert from 'App/components/VerifyAlert'
import includes from 'lodash/includes'
import FileBinary from 'react-icons/lib/go/file-binary'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import baseURL from '../../../Root/url'

@withRouter
@withGraphQL(gql`
  query getDocument($documentId: ID) {
    me {
      _id
      hasTwoFactor
      email
    }
    document(documentId: $documentId) {
      _id
      name
      feaSignAuthorization
      hasPreview
      feaNextSigner
      requireSignersOrder
      requireTwoFactor
      signAuthorization
      faceSignAuthorization
      isMyFeaTurn
      rejected {
        userId
        reason
      }
      ...signDocumentPage
    }
  }
  ${Page.fragment}
`)
@withMutation(gql`
  mutation fillDocument($documentId: ID, $fields: [FieldFillValue], $twoFactorCode: String) {
    fillDocument(documentId: $documentId, fields: $fields, twoFactorCode: $twoFactorCode) {
      _id
    }
  }
`)
@withMutation(gql`
  mutation cancelDocument($documentId: ID, $rejectReason: String) {
    cancelDocument(documentId: $documentId, rejectReason: $rejectReason) {
      _id
    }
  }
`)
@withMutation(gql`
  mutation rechazarDocumento($rejectReason: String, $idDocumento: ID) {
    rechazarDocumento(rejectReason: $documentId, idDocumento: $rejectReason) {
      _id
    }
  }
`)
@withMutation(gql`
  mutation resendVerificationEmail($email: String) {
    resendVerificationEmail(email: $email) {
      success
    }
  }
`)
@withMutation(gql`
  mutation initFeaFlow($documentId: ID!, $organizationId: ID) {
    initFeaFlow(documentId: $documentId, organizationId: $organizationId)
  }
`)

@withMessage
export default class Document extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    showMessage: PropTypes.func,
    document: PropTypes.object,
    fillDocument: PropTypes.func,
    cancelDocument: PropTypes.func,
    sign: PropTypes.bool,
    me: PropTypes.func,
    resendVerificationEmail: PropTypes.func,
    initFeaFlow: PropTypes.func
  }

  static defaultProps = {
    sign: true
  }

  state = {
    fieldsValues: {},
    fieldFontSizeOverride: 0
  }

  async sendEmail() {
    this.setState({loading: true, errorMessages: null})
    try {
      await this.props.resendVerificationEmail({email: this.props.me.email})
      this.props.showMessage('Email de confirmación enviado a tu correo.')
    } catch (error) {
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  @autobind
  async cancelarDocumento() {
    this.setState({rechazando: true})
    console.log('cancelarDocumento')
    const razonRechazo = prompt('Por favor indícanos la razón del rechazo')
    if (!razonRechazo || razonRechazo.trim() === '') {
      alert('Debe especificar la razón para el rechazo')
      this.setState({rechazando: false})
      return
    }
    console.log('Razon de rechazo es ' + razonRechazo)
    try {
      await this.props.cancelDocument(
        {
          rejectReason: razonRechazo,
          documentId: this.props.document._id,
          otroCampo: '12345'
        },
        {
          refetchQueries: [
            'getDocument',
            'documentCount',
            'organizationDocCount',
            'myDocumentsToSign',
            'myFeaDocumentsToSign',
            'planSignaturesCount',
            'packsSignaturesCount'
          ]
        }
      )
      console.log('Vuelve cancelDocument!')
      this.props.showMessage('Documento rechazado')
      setTimeout(() => {
        this.props.router.push(`/documents`)
      }, 4000
      )
    } catch (error) {
      console.log(error.message)
      this.setState({rechazando: false})
      if (includes(error.message, 'verify')) {
        this.refs.alert.toggleDialog('OutlineModal')
      } else {
        this.props.showMessage(error.message, {level: 'error'})
      }
    }
  }

  goToNextField() {
    const nextField = document.querySelector(`[data-required="true"][data-filled="false"][data-filler="${this.props.me.email}"]`)
    if (nextField) {
      window.location.hash = ``
      window.location.hash = `#${nextField.getAttribute('id')}`
      return true
    }
    return false
  }

  @autobind
  async save() {
    if (this.goToNextField()) { return }
    this.setState({loading: true})
    try {
      const fields = keys(this.state.fieldsValues).map(fieldId => ({
        fieldId,
        value: this.state.fieldsValues[fieldId]
      }))

      await this.props.fillDocument(
        {
          documentId: this.props.document._id,
          fields,
          twoFactorCode: this.state.twoFactorCode
        },
        {
          refetchQueries: [
            'documentCount',
            'documents',
            'getDocument',
            'document',
            'myDocumentsToSign',
            'myFeaDocumentsToSign',
            'organizationDocCount'
          ]
        }
      )
      
      this.props.showMessage('Documento firmado')
      if(this.props.document.faceSignAuthorization){
        this.props.router.push(`/documents/${this.props.document._id}`);
      }
      else{
        this.props.router.push(`/documents/mysigndocuments`)
      }
      
      
    } catch (error) {
      console.log(error.message)
      if (includes(error.message, 'verify')) {
        this.refs.alert.toggleDialog('OutlineModal')
      } else {
        this.props.showMessage(error.message, {level: 'error'})
      }
    }
    this.setState({loading: false})
  }



  renderAlert() {
    return <VerifyAlert onClick={() => this.sendEmail()} ref="alert" />
  }

  componentDidMount() {
    if (!this.props.document) return
    if (!this.props.document.fields) return
    let fieldsValues = {}
    each(this.props.document.fields, field => {
      if (!field.value) {
        return
      }
      if (field.type === 'text') {
        fieldsValues[field.id] = {text: field.value.text}
      } else if (field.type === 'checkbox') {
        fieldsValues[field.id] = {checked: field.value.checked}
      } else {
        fieldsValues[field.id] = {signatureId: field.value.signatureId}
      }
    })
    this.setState({fieldsValues})
  }

  // ACA RECIBE LOS DATOS DE LA FIRMA
  @autobind
  setFieldValue(fieldId, value) {
    const fieldsValues = this.state.fieldsValues
    fieldsValues[fieldId] = value
    this.setState({fieldsValues})
  }

  saveProblem() {
    if (this.props.document.requireTwoFactor && !this.props.me.hasTwoFactor) {
      return 'Necesitas tener autentificación de dos factores'
    }
    return null
  }

  renderPages() {
    console.log('renderPages')
    if (!this.props.document) return
    return this.props.document.pages.map(page => {
      const fieldsInPage = (this.props.document.fields || []).filter(
        field => field.page === page.index
      )

      return (
        <Page
          document={this.props.document}
          page={page}
          key={page.index}
          fields={fieldsInPage}
          setFieldValue={this.setFieldValue}
          fieldsValues={this.state.fieldsValues}
          sign={this.props.sign}
        />
      )
    })
  }

  renderTwoFactor() {
    if (!this.props.document.requireTwoFactor) return
    return (
      <div className={styles.twoFactor}>
        <TwoFactor
          value={this.state.twoFactorCode}
          onChange={twoFactorCode => this.setState({twoFactorCode})}
        />
      </div>
    )
  }

  renderButton() {
    if (!this.props.sign) return
    const saveProblem = this.saveProblem()
    return (
      <div className={styles.button}>
        {this.renderTwoFactor()}
        <Button
          tooltip={saveProblem}
          disabled={!!saveProblem}
          loading={this.state.loading}
          primary
          onClick={this.save}
        >
          Aceptar y Firmar
        </Button>
      </div>
    )
  }

  renderButtonBack() {
    if (this.props.sign) return
    return (
      <div className={styles.button}>
        <Button
          loading={this.state.loading}
          onClick={() => this.props.router.push(`/documents/${this.props.document._id}`)}
        >
          Atras
        </Button>
      </div>
    )
  }

  renderFontSizeControl() {
    return (
      <div className="fontSizeControls">
        <Button onClick={() => this.setState({fieldFontSizeOverride: this.state.fieldFontSizeOverride - 2})}>-</Button>
        <div style={{fontSize: '16px', marginRight: '10px'}}>Aa</div>
        <Button onClick={() => this.setState({fieldFontSizeOverride: this.state.fieldFontSizeOverride + 2})}>+</Button>
      </div>
    )
  }

  renderButtonCancelarDocumento() {
    if (!this.props.sign) return
    const saveProblem = this.saveProblem()
    return (
      <div className={styles.divCancelar}>
        <Button className={styles.btnCancelar}
          tooltip={saveProblem}
          disabled={!!saveProblem}
          loading={this.state.rechazando}
          primary
          onClick={this.cancelarDocumento}
        >
          Rechazar Documento
        </Button>
      </div>
    )
  }

  renderFeaButton() {
    // console.log("Rejected: ", this.props.document.rejected)
    if (this.props.document.rejected) {
      return
    }
    let iFea = this.props.document.feaSignAuthorization
    let nextFea = this.props.document.feaNextSigner
    // console.log('PermisosFEA: ' + nextFea + ' - ' + iFea);
    let mensajeNext = 'Aún no es tu turno para aplicar la firma'
    if (nextFea) { mensajeNext = 'Serás redirigido eCertChile' }
    // console.log("Next Fea: "+ nextFea);
    if (iFea) {
      return (
        <div className="col-xs-12 end-md">
          <div className={styles.feaState}>
            <Tooltip content={mensajeNext}>
              <Button onClick={() => { this.gotoECert() } } loading={this.state.fealoading}
                disabled={!nextFea} primary><FileBinary size={20} style={{color: '#3cb371'}}/>&nbsp;Aplicar Firma Avanzada</Button>
            </Tooltip>
          </div>
        </div>
      )
    } else {
      return (
        <div className="col-xs-6 col-sm-6"></div>
      )
    }
  }

  @autobind
  async gotoECert() {
    this.setState({ fealoading: true })
    try {
      localStorage.setItem('active', true)
      localStorage.setItem('docId', this.props.document._id)
      localStorage.setItem('docLink', window.location.href.split('?')[0].split('#')[0])
      let feaFlowResponse = await this.props.initFeaFlow({documentId: this.props.document._id, organizationId: null})
      this.props.showMessage('Re dirigiendo para firma electrónica avanzada')
      let newUrl = feaFlowResponse.initFeaFlow.ecertSignUrl
      localStorage.removeItem('docLink')
      localStorage.removeItem('docId')
      localStorage.removeItem('active')
      window.location.href = newUrl
    } catch (e) {
      this.props.showMessage(e.message, {level: 'error'})
      this.setState({ fealoading: false })
      if (e.message.indexOf('perfil') > 0) {
        setTimeout(this.props.router.push(`/settings`), 5000)
      }
      // ccastellanos@vincitrent.cl
    } finally {
    }
  }

  render() {
    if (this.props.document.rejected && this.props.document.rejected.reason) {
      // alert('Documento ha sido cancelado')
      window.location.href = `/documents/${this.props.document._id}`
      return null
    } else {
      if (
        !this.props.document ||
        (this.props.document.signAuthorization === false && this.props.sign === true)
      ) {
        return (
          <div className="section">
            <div className="header">
              <p>Usted ya firmó o no tiene los permisos para acceder al documento.</p>
              <p>Revisa si ingresaste con la misma cuenta de correo a la que se envió el email</p>
            </div>
          </div>
        )
      } else {
        return (
          <div className={styles.container} style={{'--font-diff': this.state.fieldFontSizeOverride}}>
            <div className="section">
              <FixedHeader>
                <div className="header">
                  <h3 className={styles.name}>{this.props.document.name}</h3>
                  {this.renderButtonCancelarDocumento()}
                  {this.renderButton()}
                  {this.renderFontSizeControl()}
                  {this.renderButtonBack()}
                  {this.renderFeaButton()}
                </div>
              </FixedHeader>
              <div className={`pages ${styles.pages}`}>
                {this.renderPages()}
              </div>
            </div>
            {this.renderAlert()}
          </div>
        )
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Document/index.js